module.exports = __webpack_public_path__ + "static/media/Put Back Blue.b66c955f.svg";